module.exports = __webpack_public_path__ + "img/tim-pro.6958da78.jpg";